import { render, staticRenderFns } from "./touchDrainageCardNew.vue?vue&type=template&id=3f945452&scoped=true"
import script from "./touchDrainageCardNew.vue?vue&type=script&lang=js"
export * from "./touchDrainageCardNew.vue?vue&type=script&lang=js"
import style0 from "./touchDrainageCardNew.vue?vue&type=style&index=0&id=3f945452&prod&lang=less&scoped=true"
import style1 from "./touchDrainageCardNew.vue?vue&type=style&index=1&id=3f945452&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f945452",
  null
  
)

export default component.exports